module.exports = __webpack_public_path__ + "static/media/02.9b8cdefe.jpg";